import { 
    FETCH_USER_VALIDITY, 
    URL
} from './types';

export const getUserValidity = (token) => dispatch => {
    fetch(URL + 'api/get_user_validity/', {
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        })
    })
    .then(res=>res.json())
    .then(res=>
        dispatch({
            type: FETCH_USER_VALIDITY,
            payload: res
        }) 
    )
}


// WEBPACK FOOTER //
// ./src/actions/validityActions.js